module.exports = __webpack_public_path__ + "static/icons/icon-chevron-right--white-ce06166c3a07caf4b068b782bfda8456.svg";